export var EntityTypes = /*#__PURE__*/ function(EntityTypes) {
    EntityTypes["ClientJob"] = "ClientJob";
    EntityTypes["TalentPool"] = "TalentPool";
    EntityTypes["OnboardingRequest"] = "OnboardingRequest";
    EntityTypes["OnboardingPackage"] = "OnboardingPackage";
    return EntityTypes;
}({});
export var CollaboratorTypes = /*#__PURE__*/ function(CollaboratorTypes) {
    CollaboratorTypes["Collaborator"] = "Collaborator";
    CollaboratorTypes["Guest"] = "Guest";
    CollaboratorTypes["AccountManager"] = "AccountManager";
    return CollaboratorTypes;
}({});
